export class SocialMediaLinkUtilities {
    public static getFacebookLink(userId: string): string {
        return 'https://www.facebook.com/' + userId;
    }

    public static getInstagramLink(userId: string): string {
        return 'https://www.instagram.com/' + userId;
    }

    public static getTwitterLink(userId: string): string {
        return 'https://www.twitter.com/' + userId;
    }

    public static getLinkedInLink(userId: string): string {
        return 'https://www.linkedin.com/' + userId;
    }
    
    public static getEmailLink(userId: string): string {
        return 'mailto:' + userId;
    }
}
